import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import VideoCall from "../Call/VideoCall";

const FooterVideoCallTrigger = () => {
  const { currentUser } = useAuth();
  const [videoCallOpen, setVideoCallOpen] = useState(false);

  const openFooterCall = () => {
    if (!currentUser?.uid) return;
    setVideoCallOpen(true);
  };

  const closeFooterCall = () => {
    setVideoCallOpen(false);
  };

  return (
    <>
      <button
        onClick={openFooterCall}
        style={{
          padding: "8px 16px",
          fontSize: 14,
          borderRadius: 6,
          border: "none",
          background: "#1976d2",
          color: "#fff",
          cursor: "pointer",
        }}
      >
        Video Call - Footer Room
      </button>

      {videoCallOpen && currentUser?.uid && (
        <VideoCall
          roomId="video-room"           // Unique footer room
          userId={currentUser.uid}      // Pass current user ID
          onClose={closeFooterCall}
        />
      )}
    </>
  );
};

export default FooterVideoCallTrigger;
